import { defaultHeight, defaultWidth, offset } from "../defaults.js";

const drawCaseCondition = (container, data, onDrag) => {
  const bindingData = [data];
  const cline1 = container.selectAll("line.cline1").data(bindingData);
  cline1
    .enter()
    .append("line")
    .classed("cline1", true)
    .merge(cline1)
    .attr("x1", (d) =>
      d.index === 0 ? -offset : d.precedingPosition?.x - d.position.x + offset
    )
    .attr("x2", (d) => (!d.index || d.index === 0 ? 0 : 5))
    .attr("y1", 5)
    .attr("y2", 5);
  cline1.exit().remove();

  const cline3 = container.selectAll("line.cline3").data(bindingData);
  cline3
    .enter()
    .append("line")
    .classed("cline3", true)
    .merge(cline3)
    .attr("x1", defaultWidth / 2)
    .attr("y1", defaultHeight - 4)
    .attr("x2", defaultWidth / 2)
    .attr("y2", defaultHeight + 5);
  cline3.exit().remove();

  const cpoly = container.selectAll("polygon.cpoly").data(bindingData);
  cpoly
    .enter()
    .append("polygon")
    .classed("cpoly", true)
    .merge(cpoly)
    .attr(
      "points",
      () =>
        `${defaultWidth / 2},${defaultHeight - 4} ${defaultWidth - 4},-0 4,-0`
    );
  cpoly.exit().remove();

  const conditionLabel = container
    .selectAll("text.condition-label")
    .data((d) => [d]);
  conditionLabel
    .enter()
    .append("text")
    .classed("condition-label", true)
    .merge(conditionLabel)
    .attr("x", (d) => d.labelPosition?.x ?? -4)
    .attr("y", (d) => {
      const y = d.labelPosition?.y ?? -10;
      return y > -4 ? -4 : y;
    })
    .attr("dy", "0.35em")
    .text((d) => d.label || "c?")
    .call(onDrag);
  conditionLabel.exit().remove();
};

export { drawCaseCondition };
